export const PERFORMANCE_LOADING = "PERFORMANCE_LOADING";
export const PERFORMANCE_RESET = "PERFORMANCE_RESET";
export const GET_PERFORMANCE = "GET_PERFORMANCE";
export const GET_PERFORMANCE_SUCCESS = "GET_PERFORMANCE_SUCCESS";
export const GET_PERFORMANCE_FAIL = "GET_PERFORMANCE_FAIL";
export const DELETE_PERFORMANCE = "DELETE_PERFORMANCE"
export const DELETE_PERFORMANCE_SUCCESS = "DELETE_PERFORMANCE_SUCCESS"
export const DELETE_PERFORMANCE_FAIL = "DELETE_PERFORMANCE_FAIL"
export const UPDATE_PERFORMANCE = "UPDATE_PERFORMANCE"
export const UPDATE_PERFORMANCE_SUCCESS = "UPDATE_PERFORMANCE_SUCCESS"
export const UPDATE_PERFORMANCE_FAIL = "UPDATE_PERFORMANCE_FAIL"
export const ADD_NEW_PERFORMANCE = "ADD_NEW_PERFORMANCE"
export const ADD_PERFORMANCE_SUCCESS = "ADD_PERFORMANCE_SUCCESS"
export const ADD_PERFORMANCE_FAIL = "ADD_PERFORMANCE_FAIL"